import React, { useState } from 'react';
import Button from 'src/components/Button/Button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { ProjectDeleteContent } from 'src/components/ProjectSettings/Popups/ProjectDeleteContent';
import { DeleteIcon } from 'src/assets/img/delete-icon';

export const DeleteProjectModal = ({
  disabled = false,
  redirect = undefined,
  setOpenModal = (_open?: any) => {},
  trigger = (
    <Button
      className={clsx(
        disabled && 'pointer-events-none opacity-50',
        'cursor-pointer transparent max-md:mt-0 flex items-center gap-2 red',
      )}
    >
      <p className="max-md:text-xs text-delete font-bold max-md:font-medium">
        Delete <span className="max-md:hidden">project</span>
      </p>
      <DeleteIcon />
    </Button>
  ),
  project = {},
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
    setOpenModal(false);
  };

  const onOpenChangeHandler = (open) => {
    setOpen(open);
    setOpenModal(open);
  };

  return (
    <Dialog onOpenChange={onOpenChangeHandler} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Delete project
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <ProjectDeleteContent redirect={redirect} close={closePopup} project={project} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
